// src/stockx/base/BuyingIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var BuyingIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  colorized && /* @__PURE__ */ jsx("path", { d: "M42.91 17.71H6.92004V40.25H42.91V17.71Z", fill: "#D4D1C7" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M29.63 17.39H20.36V24.95H29.63V17.39Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M27.79 9.21002H22.21L20.36 17.39H29.64L27.79 9.21002Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M37.21 33.78H29.64V36.03H37.21V33.78Z",
      fill: colorized ? "#006340" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M39.45 7.5H10.55L5.89001 17.71V19.03V42.5H44.11V19.03V17.71L39.45 7.5ZM12.14 9.75H37.86L41.4 16.78H8.61001L12.14 9.75ZM41.86 40.25H8.14002V19.1H41.86V40.25Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var BuyingIcon_default = BuyingIcon;

export {
  BuyingIcon_default
};
